import React from "react";
import { View, StyleSheet, ViewProps } from "react-native";

import Icon from "component/typography/Icon";
import Text from "component/typography/Text";
import { mq } from "utils";
import { colors } from "asset/constant";

export default function Empty(props: EmptyT & ViewProps) {
  const { message, icon, style } = props;

  return (
    <View style={[styles.container, style]}>
      {icon ? (
        <Icon {...icon} />
      ) : (
        <Icon name="search1" size={mq(40)} style={{ marginTop: mq(20) }} />
      )}
      <Text
        weight="extraBold"
        size={"lg"}
        color={colors.text.muted}
        style={{ marginTop: mq(15) }}
      >
        {message}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: { alignItems: "center", justifyContent: "center" },
});
